'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateSubsectionState = exports.toggleSection = exports.toggleSitemap = exports.toggleMainMenu = exports.init = undefined;

var _types = require('./types');

var init = exports.init = function init(sectionsMenu) {
    return {
        type: _types.UI_INIT,
        payload: {
            sectionsMenu: sectionsMenu
        }
    };
};

var toggleMainMenu = exports.toggleMainMenu = function toggleMainMenu() {
    return {
        type: _types.UI_TOGGLE_MAIN_MENU
    };
};

var toggleSitemap = exports.toggleSitemap = function toggleSitemap() {
    return {
        type: _types.UI_TOGGLE_SITEMAP
    };
};

var toggleSection = exports.toggleSection = function toggleSection(sectionName) {
    return {
        type: _types.UI_TOGGLE_SECTION,
        payload: {
            sectionName: sectionName
        }
    };
};

var generateSubsectionState = exports.generateSubsectionState = function generateSubsectionState(sectionsMenu) {
    return {
        type: _types.UI_GENERATE_SUBSECTIONS_STATE,
        payload: {
            sectionsMenu: sectionsMenu
        }
    };
};
//# sourceMappingURL=actions.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/redux/core-navigation-ui/actions.js
 ** module id = 293
 ** module chunks = 1
 **/